import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable()
export class GlobalBannerHelperService {

  readonly CONST_CLOSED_BANNER_KEY = 'closedBannerValues';
  readonly CONST_CLOSED_BANNER_RESET_CTR_KEY = 'closedBannerResetCounter';

  private renderer: Renderer2;

  get closedGlobalBannerValues() {
    return sessionStorage.getItem(this.CONST_CLOSED_BANNER_KEY) || '';
  }
  set closedGlobalBannerValues(value: string) {
    sessionStorage.setItem(this.CONST_CLOSED_BANNER_KEY, value);
  }

  get closedBannerResetCounter() {
    const sessVal = sessionStorage.getItem(this.CONST_CLOSED_BANNER_RESET_CTR_KEY);
    return Number((sessVal ? sessVal : 0));
  }
  set closedBannerResetCounter(value: number) {
    sessionStorage.setItem(this.CONST_CLOSED_BANNER_RESET_CTR_KEY, value.toString());
  }

  constructor(
    rendererFactory: RendererFactory2
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  /**
   * checks if global banner is already been closed
   * @public
   */
  public isGlobalBannerHasBeenClosed(bannerMsg: string): boolean {
    let result = false;
    bannerMsg = this.stripHtml(bannerMsg);
    result = this.closedGlobalBannerValues.toLocaleLowerCase().trim().includes(bannerMsg.toLocaleLowerCase().trim());
    return result;
  }

  /**
   * strip html from string
   * @public
   */
  public stripHtml(html: string): string {
    const tempDivElement = this.renderer.createElement('div');
    this.renderer.setProperty(tempDivElement, 'innerHTML', html);
    return tempDivElement.textContent || tempDivElement.innerText;
  }

  /**
   * save closed banner msg to sessionStorage
   * @public
   */
  public saveToClosedBanner(bannerMsg: string): void {
    bannerMsg = this.stripHtml(bannerMsg);
    if (this.isGlobalBannerHasBeenClosed(bannerMsg)) {
      return;
    }
    const newBannerMsg = this.closedGlobalBannerValues
      ? this.closedGlobalBannerValues + '#,#' + bannerMsg
      : bannerMsg;
    this.closedGlobalBannerValues = newBannerMsg;
  }

  /**
   * delete closed banner msg from sessionStorage
   * @public
   */
  public resetClosedBanner(): void {
    sessionStorage.removeItem(this.CONST_CLOSED_BANNER_KEY);
  }

  /**
   * delete closed banner reset counter from sessionStorage
   * @public
   */
  public resetClosedBannerResetCtr(): void {
    sessionStorage.removeItem(this.CONST_CLOSED_BANNER_RESET_CTR_KEY);
  }

}
